<ng-content></ng-content>

<button class="hidden" (click)="toggleContent()" ui-button uiShape="round" uiType="link" uiSize="small">
  {{ isExpanded ? ("view_less" | localize) : ("view_more" | localize) }}
</button>
